<template>
  <div>
    <slot name="post-header"></slot>
    <slot name="breadcrumb"></slot>

    <div
      class="membership-layout-container membership-lesson-container flex md:flex-row flex-col md:space-x-5 h-screen"
    >
      <div
        v-if="courseSettings.sidebar_position == 2"
        class="md:w-4/12 w-full flex flex-col space-y-5 md:mt-0 mt-5"
      >
        <div v-if="courseSettings.show_sidebar_img == 1">
          <slot name="featured-image"></slot>
        </div>
        <slot name="instructor"></slot>
        <slot
          v-if="courseSettings.show_progressbar == 1"
          name="progress-bar"
        ></slot>
        <slot name="hierarchy"></slot>
      </div>
      <div class="w-full md:w-8/12 post-canvas-container">
        <div
          v-if="loading"
          style="height: 50vh"
          class="flex items-center justify-center"
        >
          <half-circle-spinner
            style="display: block; margin: 0 auto"
            :animation-duration="1000"
            :size="60"
            :color="loaderColor"
          />
        </div>
        <div class="mb-6">
          <slot name="post-canvas"></slot>
          <slot name="post-locked"></slot>
        </div>

        <slot
          v-if="courseSettings.show_progressbar == 1"
          name="mark-as-complete"
        ></slot>
      </div>
      <div
        v-if="courseSettings.sidebar_position == 1"
        class="md:w-4/12 w-full flex flex-col space-y-5 md:mt-0 mt-5"
      >
        <div v-if="courseSettings.show_sidebar_img == 1">
          <slot name="featured-image"></slot>
        </div>
        <slot name="instructor"></slot>
        <slot
          v-if="courseSettings.show_progressbar == 1"
          name="progress-bar"
        ></slot>
        <slot name="hierarchy"></slot>
      </div>
    </div>
    <slot name="post-footer"></slot>
  </div>
</template>
<script>
import { HalfCircleSpinner } from 'epic-spinners';
export default {
  name: 'PostMarkup',
  data() {
    return {
      loaderColor: '#FD6481',
    };
  },
  components: {
    HalfCircleSpinner,
  },
  props: {
    activeElement: {},
    courseSettings: {},
  },
  computed: {
    loading() {
      if (this.activeElement.value.is_locked.status) {
        return false;
      }
      return !this.activeElement.sectionsLoaded;
    },
  },
};
</script>